//styles
import { GlobalStyle } from './GlobalStyle';
import React from 'react';
//Routing
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

//Components
import Header from './components/Header';
import Navbar from "./components/Navbar";
import Home from './components/Home';
import Movie from './components/Movie';
import NotFound from './components/NotFound';
import FilmRecommendationForm from './components/FilmRecommendationForm';
import FilmRecommendation from './components/FilmRecommendation';
import About from "./pages/about";
import Teams from "./pages/team";
import Blogs from "./pages/blog";
import BlogPost from './pages/BlogPost';
import AuthCallback from './pages/AuthCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SignUpForm from './pages/sign-up';
import SignIn from './pages/sign-in';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Footer from './components/Footer';
import { ThreadsAuthProvider } from './context/ThreadsAuthContext';
import { AdminAuthProvider, useAdminAuth } from './context/AdminAuthContext';
import { UserAuthProvider, useUserAuth } from './context/UserAuthContext';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import ActorPage from './components/ActorPage';

// Redirects legacy /{numericId} URLs (old route format) → /movie/{numericId}
// Fixes broken pages Google has indexed from an older version of the app
const LegacyMovieRedirect = () => {
  const { id } = useParams();
  if (/^\d+$/.test(id)) {
    return <Navigate to={`/movie/${id}`} replace />;
  }
  return <NotFound />;
};

// Guards /admin/dashboard — redirects to login if not authenticated
const ProtectedAdmin = () => {
  const { isAdmin } = useAdminAuth();
  return isAdmin ? <AdminDashboard /> : <Navigate to="/admin/login" replace />;
};

// Guards /my-films — redirects to sign-in if not logged in
const ProtectedUser = () => {
  const { isLoggedIn } = useUserAuth();
  return isLoggedIn ? <UserDashboard /> : <Navigate to="/sign-in" replace />;
};

const App = () => (
  <HelmetProvider>
    <AdminAuthProvider>
      <UserAuthProvider>
        <ThreadsAuthProvider>
          <Router>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Header />
              {/* <Navbar /> */}
              <div style={{ flex: 1 }}>
                <Routes>
                  <Route path='/' element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/team" element={<Teams />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/blogs/:slug" element={<BlogPost />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/sign-up" element={<SignUpForm />} />
                  <Route path="/sign-in" element={<SignIn />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path='/filmrecommendationform' element={<FilmRecommendationForm />} />
                  <Route path='/filmrecommendation' element={<FilmRecommendation />} />
                  <Route path='/movie/:movieSlug' element={<Movie />} />
                  <Route path='/actor/:actorId' element={<ActorPage />} />
                  <Route path='/admin/login' element={<AdminLogin />} />
                  <Route path='/admin/dashboard' element={<ProtectedAdmin />} />
                  <Route path='/my-films' element={<ProtectedUser />} />
                  <Route path='/:id' element={<LegacyMovieRedirect />} />
                  <Route path='/*' element={<NotFound />} />
                </Routes>
              </div>
              <Footer />
            </div>
            <GlobalStyle />
          </Router>
        </ThreadsAuthProvider>
      </UserAuthProvider>
    </AdminAuthProvider>
  </HelmetProvider>
);

export default App;